import { IConsuptionOptions } from '@/app/core/interfaces/consumption.interface';

export class GetATRAction {
  static readonly type = '[atr] Get ATR Data';
  constructor(public payload: IConsuptionOptions) {}
}

export class ClearFiltersATR {
  static readonly type = '[atr] Clear Filters';
}

export class ResetClearFiltersATR {
  static readonly type = '[atr] Reset Clear Filters';
}
